import { TractorList } from '@src/tractor/domain/Tractor';
import { TractorClient } from '@src/tractor/services/TractorClient';
import { useQuery } from '@tanstack/react-query';

export const useTractors = (clientId: string) => {
  const { data: tractors = new TractorList([]), isLoading } =
    useQuery<TractorList>({
      queryKey: ['tractors.list', clientId],
      queryFn: () => TractorClient.list(clientId),
    });
  return {
    tractors,
    isLoading,
  };
};
